import React from 'react';
import { ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import AccountSectionTitle from '@/components/my-account/AccountSectionTitle';
import { useTranslations } from 'next-intl';

interface MyCSMPageProps extends ModuleBasePropsModel {
  name: string;
  email: string;
}

interface MyCSMPageData extends ModuleBaseModel<MyCSMPageProps> {}

const MyCSMPage: React.FC<MyCSMPageData> = (data) => {
  const { props } = data;
  const t = useTranslations();

  if (!props) return null;

  return (
    <div className="container mx-auto my-3 lg:px-2 lg:pt-2">
      <div className="mb-4">
        <div className="w-full">
          <div className="cms-section rounded bg-white shadow-none">
            <AccountSectionTitle text={t('myAccount.$myCsm')} description={t('myAccount.myCsm.$myCsmText')} />

            <div className="p-4">
              <div className="mb-4 flex flex-col items-start md:flex-row md:items-center">
                <div className="mb-5 md:mb-0">
                  <span className="font-sohne ml-3 text-[26px] leading-8 font-light text-black">{props.name}</span>
                </div>
                <div className="flex-1"></div>
                <a
                  href={`mailto:${props.email}`}
                  className="ml-3 rounded-3xl border border-black/20 px-4 py-2 text-base leading-[22px] font-semibold text-black hover:border-black md:ml-0"
                >
                  {t('myAccount.myCsm.$scheduleameetingLabel')}
                </a>
              </div>
              <hr className="border-t border-gray-300" />

              <div className="sub-section email">
                <div className="pl-0">
                  <div className="my-2 text-lg leading-[22px] font-semibold text-black">
                    {t('myAccount.myCsm.$emailLabel')}
                  </div>
                  <div className="mb-5 text-base text-black">{props.email}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyCSMPage;
